import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Calendar } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { api } from "@/lib/site";

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get(`/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setError("Post not found"));
  }, [slug]);

  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="blog-post-page">
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <Link
            to="/#blog"
            className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white mb-10"
          >
            <ArrowLeft size={14} /> Back to insights
          </Link>

          {error && <div className="text-slate-400">{error}</div>}
          {post && (
            <article>
              <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
                <Calendar size={12} />
                {new Date(post.created_at).toLocaleDateString("en-US", {
                  month: "long",
                  day: "numeric",
                  year: "numeric",
                })}
              </div>
              <h1 className="mt-5 font-display font-bold text-4xl md:text-5xl tracking-tight text-white leading-[1.05]">
                {post.title}
              </h1>
              <p className="mt-5 text-lg text-slate-400 leading-relaxed">{post.excerpt}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {post.tags?.map((t) => (
                  <span key={t} className="text-[11px] font-mono uppercase tracking-wider px-2.5 py-1 rounded-full bg-white/5 border border-white/10 text-slate-300">
                    {t}
                  </span>
                ))}
              </div>
              {post.cover_image && (
                <img
                  src={post.cover_image}
                  alt={post.title}
                  className="mt-10 w-full rounded-2xl border border-white/10"
                />
              )}
              <div className="prose prose-invert mt-10 text-slate-300 leading-relaxed whitespace-pre-wrap font-body text-base">
                {post.content}
              </div>
            </article>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
